import React, { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { BsXCircle, BsArrowRepeat } from "react-icons/bs";
import { clearCheckoutSession } from "../../utils/checkoutRecovery";
import { cancelCheckout } from "../../config/api";
const FAILURE_COPY = {
  cancelled: {
    title: "Payment Cancelled",
    description:
      "You closed the payment window. Your cart is still saved — you can try again when ready.",
  },
  failed: {
    title: "Payment Failed",
    description:
      "Your bank or card provider declined the payment. Please try again or use a different payment method.",
  },
  default: {
    title: "Payment Not Completed",
    description:
      "We could not complete your payment. Your cart is still saved if you would like to try again.",
  },
};

const CheckoutFailurePage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const reason = searchParams.get("reason");
  const copy = FAILURE_COPY[reason] || FAILURE_COPY.default;

  useEffect(() => {
    clearCheckoutSession();
    if (token) {
      cancelCheckout({ orderToken: token }).catch(() => {
        /* best-effort stock release */
      });
    }
  }, [token]);
  return (
    <>
      <Helmet>
        <title>{copy.title} | Knots & Krafts</title>
      </Helmet>
      <div className="min-h-screen bg-gradient-to-b from-amber-50 to-white py-16 px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-lg mx-auto bg-white rounded-2xl shadow-lg border border-amber-100 p-8 text-center"
        >
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center">
              <BsXCircle className="text-3xl text-amber-600" />
            </div>
          </div>

          <h1 className="text-2xl font-bold text-gray-900 mb-2">{copy.title}</h1>
          <p className="text-gray-600 mb-6">{copy.description}</p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/checkout"
              className="inline-flex justify-center items-center gap-2 px-6 py-3 bg-amber-500 text-white font-semibold rounded-xl hover:bg-amber-600 transition-colors"
            >
              <BsArrowRepeat />
              Try Again
            </Link>
            {token && (
              <Link
                to={`/track/${token}`}
                className="inline-flex justify-center items-center px-6 py-3 border border-gray-300 text-gray-700 font-medium rounded-xl hover:bg-gray-50 transition-colors"
              >
                Check Order Status
              </Link>
            )}
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default CheckoutFailurePage;
